import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  const isPrivacy = type === 'privacy';
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
    background: 'rgba(0,0,0,0.75)',
    backdropFilter: 'blur(4px)'
  }} onClick={onClose} data-id="element-14">
      <div className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-2xl p-8" style={{
      background: '#162030',
      border: '1px solid rgba(212,168,83,0.2)',
      boxShadow: '0 24px 80px rgba(0,0,0,0.6)'
    }} onClick={e => e.stopPropagation()} data-id="element-15">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center transition-colors" style={{
        background: 'rgba(255,255,255,0.05)',
        color: '#8A8070'
      }} aria-label="Fermer" data-id="element-16">
          ✕
        </button>

        {/* Divider accent */}
        <div className="w-12 h-0.5 mb-6" style={{
        background: 'linear-gradient(90deg, transparent, #D4A853, transparent)'
      }} data-id="element-17" />

        {isPrivacy ? <>
            <h2 className="text-2xl font-bold mb-6" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-18">
              Politique de Confidentialité
            </h2>
            <div className="space-y-5 text-sm leading-relaxed" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#C8C0B0'
        }} data-id="element-19">
              <p data-id="element-20">
                <strong style={{
              color: '#F5F0E8'
            }} data-id="element-21">
                  Dernière mise à jour :
                </strong>{' '}
                Janvier 2025
              </p>

              <section data-id="element-22">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-23">
                  1. Collecte des données
                </h3>
                <p data-id="element-24">
                  Nous collectons uniquement les informations nécessaires au
                  traitement de votre commande : adresse email et informations
                  de paiement. Ces données sont utilisées exclusivement pour
                  vous envoyer votre guide numérique et vous tenir informée des
                  mises à jour éventuelles.
                </p>
              </section>

              <section data-id="element-25">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-26">
                  2. Utilisation des données
                </h3>
                <p data-id="element-27">
                  Vos données personnelles ne sont jamais vendues, louées ou
                  partagées avec des tiers à des fins commerciales. Elles sont
                  utilisées uniquement pour :
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-28">
                  <li data-id="element-29">Traiter et confirmer votre achat</li>
                  <li data-id="element-30">Vous envoyer le produit numérique par email</li>
                  <li data-id="element-31">Vous contacter en cas de problème technique</li>
                </ul>
              </section>

              <section data-id="element-32">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-33">
                  3. Cookies
                </h3>
                <p data-id="element-34">
                  Ce site utilise des cookies techniques essentiels au bon
                  fonctionnement de la page. Aucun cookie de tracking
                  publicitaire n'est utilisé sans votre consentement explicite.
                </p>
              </section>

              <section data-id="element-35">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-36">
                  4. Sécurité
                </h3>
                <p data-id="element-37">
                  Toutes les transactions sont sécurisées via un protocole SSL.
                  Les informations de paiement sont traitées par notre
                  prestataire de paiement certifié et ne sont jamais stockées
                  sur nos serveurs.
                </p>
              </section>

              <section data-id="element-38">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-39">
                  5. Vos droits (RGPD)
                </h3>
                <p data-id="element-40">
                  Conformément au Règlement Général sur la Protection des
                  Données (RGPD), vous disposez d'un droit d'accès, de
                  rectification et de suppression de vos données personnelles.
                  Pour exercer ces droits, vous pouvez nous contacter par email.
                </p>
              </section>

              <section data-id="element-41">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-42">
                  6. Conservation des données
                </h3>
                <p data-id="element-43">
                  Vos données sont conservées pendant la durée nécessaire à la
                  fourniture du service et conformément aux obligations légales
                  en vigueur, soit une durée maximale de 3 ans après votre
                  dernier achat.
                </p>
              </section>
            </div>
          </> : <>
            <h2 className="text-2xl font-bold mb-6" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-44">
              Conditions Générales de Vente
            </h2>
            <div className="space-y-5 text-sm leading-relaxed" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#C8C0B0'
        }} data-id="element-45">
              <p data-id="element-46">
                <strong style={{
              color: '#F5F0E8'
            }} data-id="element-47">
                  Dernière mise à jour :
                </strong>{' '}
                Janvier 2025
              </p>

              <section data-id="element-48">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-49">
                  1. Nature du produit
                </h3>
                <p data-id="element-50">
                  Le guide <em data-id="element-51">"10 minutes pour éteindre le cerveau"</em> est un
                  produit numérique (PDF) livré par voie électronique. En tant
                  que produit dématérialisé, il ne peut faire l'objet d'un
                  retour ou d'un remboursement une fois téléchargé ou consulté.
                </p>
              </section>

              <section data-id="element-52">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-53">
                  2. Prix et paiement
                </h3>
                <p data-id="element-54">
                  Le prix affiché est en euros (€), toutes taxes comprises. Le
                  paiement est exigible immédiatement à la commande. Nous
                  acceptons les principales cartes bancaires via notre
                  prestataire de paiement sécurisé.
                </p>
              </section>

              <section data-id="element-55">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-56">
                  3. Livraison
                </h3>
                <p data-id="element-57">
                  Le produit est livré par email dans les minutes suivant la
                  confirmation du paiement. En cas de non-réception dans les 24
                  heures, vérifiez votre dossier spam avant de nous contacter.
                </p>
              </section>

              <section data-id="element-58">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-59">
                  4. Droit de rétractation
                </h3>
                <p data-id="element-60">
                  Conformément à l'article L221-28 du Code de la consommation,
                  le droit de rétractation ne s'applique pas aux contenus
                  numériques fournis sur un support immatériel dont l'exécution
                  a commencé avec l'accord préalable du consommateur.
                </p>
              </section>

              <section data-id="element-61">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-62">
                  5. Propriété intellectuelle
                </h3>
                <p data-id="element-63">
                  L'intégralité du contenu de ce guide est protégée par le droit
                  d'auteur. Toute reproduction, distribution ou revente, même
                  partielle, est strictement interdite sans autorisation écrite
                  préalable.
                </p>
              </section>

              <section data-id="element-64">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-65">
                  6. Avertissement médical
                </h3>
                <p data-id="element-66">
                  Ce guide est un outil de bien-être à visée informative et
                  éducative. Il ne constitue en aucun cas un avis médical et ne
                  remplace pas une consultation auprès d'un professionnel de
                  santé. En cas de troubles du sommeil sévères ou persistants,
                  consultez un médecin.
                </p>
              </section>

              <section data-id="element-67">
                <h3 className="text-base font-semibold mb-2" style={{
              color: '#D4A853'
            }} data-id="element-68">
                  7. Droit applicable
                </h3>
                <p data-id="element-69">
                  Les présentes conditions sont soumises au droit français. En
                  cas de litige, une solution amiable sera recherchée en
                  priorité.
                </p>
              </section>
            </div>
          </>}
      </div>
    </div>;
}
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full py-8 px-6 border-t" style={{
      background: '#0D1B2A',
      borderColor: 'rgba(255,255,255,0.05)'
    }} data-id="element-70">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-71">
          <p className="text-xs text-center md:text-left" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#8A8070'
        }} data-id="element-72">
            © 2025 · Tous droits réservés · Produit numérique
          </p>

          <div className="flex items-center gap-1" style={{
          color: '#8A8070'
        }} data-id="element-73">
            <button onClick={() => setOpenModal('privacy')} className="text-xs px-3 py-1 rounded transition-colors hover:text-amber-400" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-74">
              Politique de Confidentialité
            </button>
            <span className="text-xs" style={{
            color: 'rgba(255,255,255,0.1)'
          }} data-id="element-75">
              |
            </span>
            <button onClick={() => setOpenModal('terms')} className="text-xs px-3 py-1 rounded transition-colors hover:text-amber-400" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#8A8070'
          }} data-id="element-76">
              Conditions Générales de Vente
            </button>
          </div>
        </div>
      </footer>

      <Modal type={openModal} onClose={() => setOpenModal(null)} data-id="element-77" />
    </>;
}